/** A token job's sync state as a dot and a word, the way LiveToggle shows the event stream. */
import type { SyncState } from "@/lib/jobs";

const DOT: Record<SyncState["tone"], string> = {
  ok: "bg-ok",
  warn: "bg-warn",
  danger: "bg-danger",
  neutral: "bg-neutral",
};
const TEXT: Record<SyncState["tone"], string> = {
  ok: "text-fg",
  warn: "text-warn",
  danger: "text-danger",
  neutral: "text-fg-muted",
};

export function SyncStatus({ state }: { state: SyncState }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap ${TEXT[state.tone]}`}
      title={state.detail}
    >
      <span className={`inline-block h-2 w-2 shrink-0 rounded-full ${DOT[state.tone]}`} aria-hidden />
      {state.label}
    </span>
  );
}
